import React, { Component } from "react";
import { ButtonToolbar, Badge, Dropdown } from "react-bootstrap";

import NoTableData from "../../../components/extensions/ErrorPageDefaults/NoTableData";

import { numberWithCommas } from "../../../helpers/dataHelpers";
import { DropdownButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

import {
  DailyReportsPdfToRenderOverallComponent,
  DailyReportsPdfToRenderAreaComponent,
  DailyReportsPdfToRenderBranchComponent,
} from "./DailyReportsPdfToRenderComponent";

import {
  DailyReportsExcelToRenderOverallComponent,
  DailyReportsExcelToRenderAreaComponent,
  DailyReportsExcelToRenderBranchComponent,
} from "./DailyReportsExcelToRenderComponent";
import TableLoader from "../../../components/extensions/TableLoader";

class DailyReportsViewer extends Component {
  state = {
    isLoading: false,
    areaList: [],
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    setTimeout(() => {
      this.setState({
        isLoading: false,
      });
    }, 1000);
  }

  renderPrintablePdfComponent = (list) => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
        return DailyReportsPdfToRenderOverallComponent(list);

      case "Area":
        return DailyReportsPdfToRenderAreaComponent(list);

      case "Branch":
        return DailyReportsPdfToRenderBranchComponent(list);

      default:
        return "No Value";
    }
  };

  renderPrintableExcelComponent = (list, filename) => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
        return DailyReportsExcelToRenderOverallComponent(list, filename);

      case "Area":
        return DailyReportsExcelToRenderAreaComponent(list, filename);

      case "Branch":
        return DailyReportsExcelToRenderBranchComponent(list, filename);

      default:
        return "No Value";
    }
  };

  renderNames = (data) => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
        return data.clusterName;

      case "Area":
        return data.areaName;

      case "Branch":
        return data.branchName;

      default:
        return "No Value";
    }
  };

  renderName = () => {
    let { searchBy } = this.props.data;

    switch (searchBy) {
      case "All":
      case "Cluster":
        return "Cluster";

      case "Area":
        return "Area Name";

      case "Branch":
        return "Branch Name";

      default:
        return "No Value";
    }
  };

  renderCode = (data) => {
    let { searchBy } = this.props.data;
    switch (searchBy) {
      case "All":
        return data.clusterCode;

      case "Area":
        return data.areaCode;

      case "Branch":
        return data.branchCode;

      default:
        return "No Value";
    }
  };

  renderTotalRow = () => {
    return (
      <tr className="text-success">
        <td colSpan={this.props.data.searchBy === "Branch" ? "2" : "1"}>
          <span className="float-center">TOTAL</span>
        </td>
        {/* <td>
          <span>
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.branchCount,
                0
              )
            )}
          </span>
        </td> */}

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPiecesDetail.newPawn,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total + summary.totalPiecesDetail.redeemedPawn,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total +
                  summary.totalPiecesDetail.newPawn -
                  summary.totalPiecesDetail.redeemedPawn,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total + summary.totalPrincipalDetail.newPawn,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total + summary.totalPrincipalDetail.redeemedPawn,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total +
                  summary.totalPrincipalDetail.newPawn -
                  summary.totalPrincipalDetail.redeemedPawn,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) =>
                  total +
                  summary.grossProfitDetail.totalNewPawnCharges +
                  summary.grossProfitDetail.totalRedeemedPawnCharges,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPieces,
                0
              )
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.props.data.list.reduce(
                (total, summary) => total + summary.totalPrincipal,
                0
              ),
              2
            )}
          </span>
        </td>

        <td>
          <span className="strong float-right">
            {numberWithCommas(
              this.getTotalPrincipal() / this.getTotalPieces(),
              2
            )}
          </span>
        </td>
      </tr>
    );
  };

  getTotalPrincipal = () => {
    return this.props.data.list.reduce(
      (total, summary) => total + summary.totalPrincipal,
      0
    );
  };

  getTotalPieces = () => {
    return this.props.data.list.reduce(
      (total, summary) => total + summary.totalPieces,
      0
    );
  };

  renderTable = () => {
    let { searchBy } = this.props.data;

    if (!this.props.data.list.length > 0) {
      return <NoTableData />;
    } else {
      return (
        <div id={`${searchBy}-printTable`}>
          <table className="custom-table ">
            <thead>
              <tr>
                {this.props.data.searchBy === "Branch" && (
                  <th>
                    <span className="float-left">Branch Code</span>
                  </th>
                )}
                <th>
                  <span className="float-left">{this.renderName()}</span>
                </th>
                {/* <th>
                  <span className="float-center"># of Branches</span>
                </th> */}
                <th>#Pwn</th>
                <th>#Rdm</th>
                <th>P/R Diff</th>
                <th>
                  <span className="float-right">Amt Pawn</span>
                </th>
                <th>
                  <span className="float-right">Amt Redm</span>
                </th>
                <th>
                  <span className="float-right">Amt Diff</span>
                </th>
                <th>
                  <span className="float-right">Gross</span>
                </th>
                <th>Total Pcs</th>
                <th>
                  <span className="float-right">Total Amt</span>
                </th>
                <th>
                  <span className="float-right">Ave/Amt/Pc</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.list.map((item, idx) => {
                if (item !== undefined) {
                  return (
                    <tr key={idx}>
                      {this.props.data.searchBy === "Branch" && (
                        <td>
                          <div className="float-left">
                            {this.renderCode(item)}
                          </div>
                        </td>
                      )}
                      <td>
                        <div className="float-left">
                          <div className="mr-1 d-inline">
                            {this.renderNames(item)}
                          </div>
                          {this.props.data.searchBy !== "Branch" && (
                            <Badge pill size="sm" variant="dark">
                              {this.renderCode(item)}
                            </Badge>
                          )}
                        </div>
                      </td>
                      {/* <td>
                        <span className="float-center">
                          {numberWithCommas(item.branchCount)}
                        </span>
                      </td> */}
                      <td>
                        {numberWithCommas(item.totalPiecesDetail.newPawn)}
                      </td>
                      <td>
                        {numberWithCommas(item.totalPiecesDetail.redeemedPawn)}
                      </td>
                      <td>
                        {numberWithCommas(
                          item.totalPiecesDetail.newPawn -
                            item.totalPiecesDetail.redeemedPawn
                        )}
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPrincipalDetail.newPawn,
                            2
                          )}
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPrincipalDetail.redeemedPawn,
                            2
                          )}
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.totalPrincipalDetail.newPawn -
                              item.totalPrincipalDetail.redeemedPawn,
                            2
                          )}
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(
                            item.grossProfitDetail.totalNewPawnCharges +
                              item.grossProfitDetail.totalRedeemedPawnCharges,
                            2
                          )}
                        </span>
                      </td>
                      <td>{numberWithCommas(item.totalPieces)}</td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(item.totalPrincipal, 2)}
                        </span>
                      </td>
                      <td>
                        <span className="float-right">
                          {numberWithCommas(item.averagePrincipalPerPiece, 2)}
                        </span>
                      </td>
                    </tr>
                  );
                } else {
                  return <></>;
                }
              })}
              {this.renderTotalRow()}
            </tbody>
          </table>
        </div>
      );
    }
  };

  onHandlePrint() {
    let { searchBy } = this.props.data;

    // var prtContent = document.getElementById(`${searchBy}-printTable`);
    var prtContent = document.querySelector(`.active #${searchBy}-printTable`);
    var WinPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0"
    );
    WinPrint.document.write(
      `<html><head><title>${this.props.data.filename}</title>
       <link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" >
       <style type="text/css" media="print">
        @page { size: landscape; }
      </style>
      </head><body>`
    );

    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.write(
      '<script type="text/javascript">window.print();window.close();</script>'
    );

    WinPrint.document.write("</body></html>");
    WinPrint.document.close();
  }

  renderOption = () => {
    return (
      <ButtonToolbar className="mr-3 float-left">
        <DropdownButton
          size="md"
          className="m-1"
          variant="primary"
          title={<FontAwesomeIcon icon={faPrint} />}
        >
          <Dropdown.Item
            onClick={() => {
              this.onHandlePrint();
            }}
          >
            Pdf
          </Dropdown.Item>
          {/* <PDFDownloadLink
            className="dropdown-item"
            document={this.renderPrintablePdfComponent(this.props.data.list)}
          >
            {({ blob, url, loading, error }) =>
              loading ? <Spinner size="sm" animation="border" /> : "PDF"
            }
          </PDFDownloadLink> */}
          {this.renderPrintableExcelComponent(
            this.props.data.list,
            this.props.data.filename
          )}

          {/* <Dropdown.Item>Excel</Dropdown.Item> */}
        </DropdownButton>
      </ButtonToolbar>
    );
  };

  render() {
    return (
      <div className="p-3">
        {this.renderOption()}
        {this.state.isLoading ? <TableLoader /> : this.renderTable()}
      </div>
    );
  }
}

export default DailyReportsViewer;
